
import {mapState, mapMutations} from 'vuex'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'

import {MessageBox} from 'mint-ui';
import {cartInfo, orderPlace, updateCart, getCartNum, campaignRule,userInfo} from '@/service/index'
import { Indicator } from 'mint-ui';
import countryData from './data'
import Config from '@/utils/global.js'
import GUI from './modal/GUINumber.vue'
export default {
data() {
return {

needAddress:Config.needAddress,
addressVisible: false,
pickerVisible:false,
lastName:'',
district:'',
firstName:'',
countryData:countryData,
myAddressCountry:'',
myAddressCity:'',
address:'',
mobile:'',
SubmitLoading:false,
selectedAddress:'',
isLoading1:false,
temp: [],
allCheck: true,
total: 0,
cartInfoList: [],
isLoading:true,
rule: {},
showError: false,
errorMsg: '',
showSuccess: false,
successMsg: '',
point:null,
myStoreSlots: [ {
flex: 1,
values: countryData,
defaultIndex:118,
className: 'slot1',
textAlign: 'center'
}, {
divider: true,
content: '-',
className: 'slot2'
}, {
flex: 1,
values: countryData[0].children,
defaultIndex: 0,
className: 'slot3',
textAlign: 'center'
}],
GUIVisible: false,
other: ''
}
},
computed: {
...mapState([
'global', 'categories', 'campaign', 'bread', 'goods','specName','specNameEn'
]),
specNames(){
return  this.$i18n.locale  === 'en' ? this.specNameEn : this.specName;
}
},
created() {
this.getUserInfo();
this.keepLang()
this.getCartInfo()
this.getCartNum()
this.getCampaignRuleInfo()
},
components: {
CheckIcon, InlineXNumber, Toast, Swipeout, SwipeoutItem, SwipeoutButton,GUI
},
methods: {
...mapMutations({
initCartNum: 'INIT_CART_NUM',
}),
async getCampaignRuleInfo() {
const res = await campaignRule(this.$route.query.cid);
if (res.status === 0) {
this.rule = res.data
}
},
async getCartInfo() {
const res = await cartInfo(this.$route.query.cid)
this.isLoading=false
if (res.status === 0) {
res.data.map(item => item.checked = true)
this.cartInfoList = res.data
}
},
async getUserInfo () {
const res = await userInfo(this.$route.query.cid)
if (res.status === 0) {
this.point = res.data.point

}
},
async changeCount(row) {
if(this.isLoading1)return;
this.isLoading1=true;
Indicator.open();
const param = {}
param.items = []
param.items.push({
qty: row.qty,
productId: row.productId
})

const res = await updateCart(this.$route.query.cid, param)
this.getCartNum()
Indicator.close();


if (res.status === 0) {

this.isLoading1=false;
} else {
await this.getCartInfo();
this.isLoading1=false;
row.qty = row.qty - 1;
if (res.status === 2) {
this.errorMsg = (this.$t("cartMsg.lackall"));
this.showError = true;
} else if (res.status === 3) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.lackall"));
this.showError = true;
} else if (res.status === 4) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.globalamount"));
this.showError = true;
} else if (res.status === 5) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.perskuqty"));
this.showError = true;
} else if (res.status === 6) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.globalqty"));
this.showError = true;
} else if (res.status === 7) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.typeqty"));
this.showError = true;

} else if (res.status === 8) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.catqty"));
this.showError = true;

} else if (res.status === 9) {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.orderqty"));
this.showError = true;

} else if(res.status === 10){
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.pointlack"));
this.showError = true;
} else if(res.status === 11){
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.personalamount"));
this.showError = true;
}else {
this.submitFlag = false
this.errorMsg = (this.$t("cartMsg.retry"));
this.showError = true;
}
}
},
submitData() {













this.GUIVisible = true

},
onConfirmAddCart(val){
this.other = val
if(this.rule.orderQty > 0&&this.rule.orderQty<20 ){
MessageBox.confirm(this.$t('cart.confirmOrder', {orderQty: this.rule.orderQty}), this.$t('cart.tip'), {
confirmButtonText: this.$t('cart.affirm'),
cancelButtonText: this.$t('cart.cancel'),
}).then(() => {
this.orderPlace()
}).catch(() => {

})
}else{
this.orderPlace()
}
},
confirmPicker() {


this.pickerVisible = false
},

closeOnClickModal() {
this.pickerVisible = false
},

showStorePicker() {
this.pickerVisible = true
},

onMyStoreChange(picker, values) {
console.log(values)
picker.setSlotValues(1,values[0].children);
this.myAddressCountry = values[0].label;
this.myAddressCity  = values[1].label;
},



onSubmitData() {



},

async orderPlace() {
const param = {};
param.items = [];
if(this.other){
param.gui = this.other
}
if(Config.needAddress){

if (!this.lastName) {

this.errorMsg = (this.$t("cartMsg.lastName"));
this.showError = true;
return false

} else if (!this.firstName) {
this.errorMsg = (this.$t("cartMsg.firstName"));
this.showError = true;
return false
} else if (!this.mobile) {
this.errorMsg = (this.$t("cartMsg.correctmobile"));
this.showError = true;
return false
} else if(this.selectedAddress == ''){
this.errorMsg = (this.$t("cartMsg.address"));
this.showError = true;
return false
}

if (this.address != '') {
param.address = this.myAddressCountry + this.myAddressCity + this.address
}

param.firstName=this.firstName
param.lastName=this.lastName
param.mobile=this.mobile


}

this.cartInfoList.map(item => {
if (item.checked) {
param.items.push({
productId: item.productId,
qty: item.qty
})
}
})
const res = await orderPlace(this.$route.query.cid, param);
if (res.status === 0) {
this.$router.push({path: `/orderDetailMb/${res.data.order.id}`, query: {cid: this.$route.query.cid}})
} else if (res.status === 2) {
this.successMsg = this.$t("placeorder.lack");
this.showSuccess = true;
var obj = this;
setTimeout(
function () {
obj.$router.push({
path: `/orderDetailMb/${res.data.order.id}`,
query: {cid: obj.$route.query.cid}
})
}, 3000)
} else if (res.status === 3) {
this.errorMsg = this.$t("placeorder.lackall");
this.showError = true;
} else if (res.status === 4) {
this.errorMsg = (this.$t("placeorder.globalamount"));
this.showError = true;
} else if (res.status === 5) {
this.errorMsg = (this.$t("placeorder.perskuqty"));
this.showError = true;
} else if (res.status === 6) {
this.errorMsg = (this.$t("placeorder.globalqty"));
this.showError = true;
} else if (res.status === 7) {
this.errorMsg = (this.$t("placeorder.typeqty"));
this.showError = true;
} else if (res.status === 8) {
this.errorMsg = (this.$t("placeorder.catqty"));
this.showError = true;
} else if (res.status === 9) {

this.errorMsg = (this.$t("placeorder.orderqty"));
this.showError = true;

} else if(res.status === 10){
this.errorMsg = (this.$t("placeorder.pointlack"));
this.showError = true;
} else if(res.status === 11){
this.errorMsg = (this.$t("placeorder.personalamount"));
this.showError = true;
}else {
this.errorMsg = (this.$t("placeorder.retry"));
this.showError = true;
}
},
async getCartNum() {
const cartNum = await getCartNum(this.$route.query.cid)
this.initCartNum({cartNum: cartNum.data})
},
keepLang() {
let locale = localStorage.locale;
this.$i18n.locale = locale === 'en' ? locale : 'zh';
},
goHome() {
this.$router.push({
path: `/home/${this.$route.query.cid}`,
query: {cid: this.$route.query.cid}
})
},
handleEvents (type) {
console.log('event: ', type)
},
onButtonClick (type,index) {
this.cartInfoList.splice(index,1)
this.changeCount({ ...type, qty: 0})
},
},
watch: {
cartInfoList: {
deep: true,
handler: function (val, oldVal) {
this.total = 0
let status = true;
val.map(item => {
if (item.checked) {
this.total = this.total + parseFloat(item.price) * parseInt(item.qty)
} else {
status = false
}
})
this.allCheck = status
}
},
allCheck(val, oldVal) {
let status = 0;
this.cartInfoList.map(item => {
if (item.checked) {
status++
} else {
status--
}
})
if (Math.abs(status) === this.cartInfoList.length)
this.cartInfoList.map(item => item.checked = val)
},
}
}



// WEBPACK FOOTER //
// ./src/pages/cart/CartMb.vue